import { useQuery } from 'react-query';
import { AnchorAPI } from 'client/modules/AnchorAPI';
import { FetchVerificationRedirectUrlResponse } from 'client/modules/AnchorAPI/v3/episodes/fetchVerificationRedirectUrl';

const FETCH_VERIFICATION_REDIRECT_URL_QUERY_KEY =
  'fetchVerificationRedirectUrl';

function useFetchVerificationRedirectUrl({ userId }: { userId: number }) {
  const { data } = useQuery<FetchVerificationRedirectUrlResponse>(
    [FETCH_VERIFICATION_REDIRECT_URL_QUERY_KEY],
    () => {
      return AnchorAPI.fetchVerificationRedirectUrl({
        userId,
      });
    }
  );

  return {
    data,
  };
}

export {
  FETCH_VERIFICATION_REDIRECT_URL_QUERY_KEY,
  useFetchVerificationRedirectUrl,
};
